<template>
  <div>
    <v-card flat class="rounded-lg mt-5 textLight--text">
      <v-row align="center">
        <v-col cols="12" md="2">
          <div class="font-weight-light">
            <v-row align="center">
              <!--              <v-col cols="3" class="pa-0 ms-4">
                <v-img
                  class="rounded-lg"
                  height="45"
                  max-width="45"
                  :src="
                    revenueData.training &&
                    revenueData.training.images &&
                    revenueData.training.images.length
                      ? getImage(revenueData.training.images)
                      : null
                  "
                  lazy-src="@/app/core-module/assets/images/logo_placeholder.png"
                  cover
                />
              </v-col>-->

              <v-col class="ps-3">
                <div
                  class="ms-md-3 me-0 me-md-3 align-center"
                  style="text-align: start"
                >
                  <div class="text--left ma-0 subtitle-1 text-ellipse-2">
                    <span>
                      {{
                        revenueData.training &&
                        revenueData.training.title &&
                        revenueData.training.title.length
                          ? getLocalisedValue(revenueData.training.title)
                          : "-"
                      }}
                    </span>
                  </div>
                </div>
              </v-col>
            </v-row>
          </div>
        </v-col>
        <v-col cols="12" md="2">
          <div class="text-ellipse-2 text-start">
            {{
              revenueData.organization && revenueData.organization.name
                ? getLocalisedValue(revenueData.organization.name)
                : "-"
            }}
          </div>
        </v-col>
        <v-col cols="6" md="2" class="d-flex justify-md-center">
          <div
            class="textLight--text text-ellipse-1"
            v-if="$vuetify.breakpoint.smAndDown"
          >
            {{ $t("statistics.totalEnrolments") }}:
          </div>
          <div class="text-ellipse-1">
            {{
              revenueData.totalRegistrations
                ? revenueData.totalRegistrations
                : " - "
            }}
          </div>
        </v-col>
        <v-col cols="6" md="2" class="d-flex justify-end justify-md-center">
          <div
            class="textLight--text text-truncate"
            v-if="$vuetify.breakpoint.smAndDown"
          >
            {{ $t("reports.revenues.invoiceReference") }}:
          </div>
          <div class="text-truncate">
            {{
              revenueData.trainingRegistrationInvoice &&
              revenueData.trainingRegistrationInvoice.invoiceReference
                ? revenueData.trainingRegistrationInvoice.invoiceReference
                : " - "
            }}
          </div>
        </v-col>

        <v-col cols="6" md="2" class="d-flex justify-md-center">
          <div
            class="textLight--text text-ellipse-1"
            v-if="$vuetify.breakpoint.smAndDown"
          >
            {{ $t("reports.revenues.status") }}:
          </div>
          <div v-if="revenueData.trainingRegistrationInvoice">
            <div
              :class="
                revenueData.trainingRegistrationInvoice.status === 'PAID'
                  ? 'green--text'
                  : revenueData.trainingRegistrationInvoice.status === 'UNPAID'
                  ? 'red--text'
                  : 'primary--text'
              "
            >
              {{
                revenueData.trainingRegistrationInvoice.status
                  ? revenueData.trainingRegistrationInvoice.status
                      .charAt(0)
                      .toUpperCase() +
                    revenueData.trainingRegistrationInvoice.status
                      .slice(1)
                      .toLowerCase()
                  : "-"
              }}
            </div>
          </div>
          <div v-else>-</div>
        </v-col>

        <v-col cols="6" md="2" class="d-flex justify-end justify-md-center">
          <div
            class="textLight--text text-ellipse-1"
            v-if="$vuetify.breakpoint.smAndDown"
          >
            {{ $t("user.registration.invoiceAmount") }}:
          </div>
          <div class="text-ellipse-1">
            {{
              revenueData.trainingRegistrationInvoice &&
              revenueData.trainingRegistrationInvoice.invoiceAmount
                ? revenueData.trainingRegistrationInvoice.invoiceAmount
                : " - "
            }}
          </div>
        </v-col>
      </v-row>
    </v-card>
  </div>
</template>
<script>
export default {
  props: {
    revenueData: {
      type: Object,
      required: true,
    },
  },
};
</script>
